<div class="flex h-full w-full flex-col gap-1.5">
  @if (isInternal()) {
    <div class="bg-elevated flex h-7 items-center gap-2 px-2">
      <app-badge status="pending" [showDot]="true">
        {{ 'features.planning_space.internal.badge' | translate }}
      </app-badge>
      <span class="text-text-tertiary text-[11.5px]">
        {{ 'features.planning_space.internal.hint' | translate }}
      </span>
    </div>
  }

  <app-toolbox
    [sections]="toolboxSections()"
    [showSelect]="hasSelection()"
    [selectedItemsCount]="selectedPlanIds().size"
    [displayedItemCount]="tableRows().length"
    [totalItems]="hasSelection() ? planMetadatasArray().length : 0"
    (deselectAll)="clearSelection()"
    (selectOnly)="onlySelected.set($event)" />

  <div class="flex min-h-0 w-full flex-1 flex-col">
    <as-split
      direction="vertical"
      unit="percent"
      class="h-full w-full"
      [useTransition]="true">
      <as-split-area [visible]="true">
        <app-table
          [tableId]="'planning-space'"
          [data]="tableRows()"
          [allColumns]="columns()"
          [actions]="actions()"
          [selected]="selectedPlans()"
          [config]="tableConfig"
          class="rounded-sm" />
      </as-split-area>
      <as-split-area [visible]="isGraphEnabled() || isCompareEnabled()">
        @if (isCompareEnabled()) {
          <app-kpi-comparison
            class="border-default flex h-full w-full flex-col overflow-hidden rounded-sm border"
            [items]="compareItems()"
            [decimals]="kpiDecimals()"
            [kpiOrder]="kpiOrder()"
            (closed)="closeCompare()" />
        }
        <!-- Hidden rather than destroyed, so the graph keeps its pan and zoom across a comparison. -->
        <app-planning-space-graph-visu
          class="flex h-full w-full flex-col overflow-hidden rounded-sm bg-zinc-100 dark:bg-zinc-900"
          [hidden]="isCompareEnabled()"
          [config]="graphConfig"
          [planNodes]="graphPlanNodes()"
          [planMetadata]="planMetadatasArray()"
          (planMetadataDelete)="onPlanMetadataDelete($event)"
          (planDuplicate)="openDuplicateById($event)"
          (planRename)="openRenameById($event)"
          (planNodeClick)="onPlanNodeClick($event)"></app-planning-space-graph-visu>
      </as-split-area>
    </as-split>
  </div>

  <app-duplicate-plan-flow
    [(open)]="duplicateFlowOpen"
    [planId]="duplicateTarget()?.id ?? ''"
    [sourceName]="duplicateTarget()?.name ?? ''"
    [sourceDescription]="duplicateTarget()?.description ?? ''"
    (duplicated)="onPlanDuplicated()" />

  <app-rename-plan-flow
    [(open)]="renameFlowOpen"
    [planId]="renameTarget()?.id ?? ''"
    [currentName]="renameTarget()?.name ?? ''"
    [currentDescription]="renameTarget()?.description ?? ''"
    (renamed)="onPlanRenamed()" />

  <app-delete-plans-flow
    [(open)]="deleteFlowOpen"
    [plans]="planMetadatasArray()"
    [planIds]="deleteTargetIds()"
    (completed)="onPlansDeleteCompleted()" />
</div>
